export default {
  props: {
    value: {
      type: Number,
      required: true,
    },
    unity: {
      type: String,
      required: true,
    },
    float: {
      type: Boolean,
    },
  },
  computed: {
    formattedValue() {
      if (this.float) {
        return `R$ ${this.value.toFixed(2).replace('.', ',')} ${this.unity}`;
      } else {
        return `R$ ${this.value} ${this.unity}`;
      }
    },
  },
};
